import { render } from "./ExtraProducts.vue?vue&type=template&id=009ab66d"
import script from "./ExtraProducts.vue?vue&type=script&lang=js"
export * from "./ExtraProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__